// Polyfill for e.submitter
!function(){
  var lastBtn = null
  document.addEventListener('click',function(e){
      if (!e.target.closest) return;
      lastBtn = e.target.closest('button, input[type=submit]');
  }, true);
  document.addEventListener('submit',function(e){
      if (e.submitter) return;
      var canditates = [document.activeElement, lastBtn];
      for (var i=0; i < canditates.length; i++) {
          var candidate = canditates[i];
          if (!candidate) continue;
          if (!candidate.form) continue;
          if (!candidate.matches('button, input[type=button], input[type=image]')) continue;
          e.submitter = candidate;
          return;
      }
      e.submitter = e.target.querySelector('button, input[type=button], input[type=image]')
  }, true);
}();

(function () {

  // matches
  if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector;
  }

  // closest
  if (!Element.prototype.closest) {
      Element.prototype.closest = function (css) {
          var node = this;
          while (node) {
              if (node.matches(css)) return node;
              else node = node.parentElement;
          }
          return null;
      };
  }

  // forEach
  if (!Array.prototype.forEach) {
      Array.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
              callback.call(thisArg, this[i], i, this);
          }
      };
  }
  if (typeof NodeList.prototype.forEach !== "function") {
      NodeList.prototype.forEach = Array.prototype.forEach;
  }

})();